/**
 * Template variables — the org's merge-field registry.
 *
 * Org admins manage the org's own variables; other staff get a read-only view.
 * Backed by /api/template-variables (BE #1220).
 */

import TemplateVariablesManager from '@/components/admin/TemplateVariablesManager';

export default function TemplateVariablesPage() {
  return <TemplateVariablesManager />;
}
